import React from 'react';
import { Button, ButtonClean, Loader, Subsection } from '@fourthwall/components';
import { useCurrentShop } from '@modules/Dashboard/hooks/useCurrentShop';
import * as S from './HMAC.styled';
import { HMACDisplay } from './components/HMACDisplay/HMACDisplay';
import { useHMAC } from './hooks/useHMAC';
export const HMAC = () => {
    const { currentShopQuery } = useCurrentShop();
    const { hmac, loading, updateHMAC, updateLoading } = useHMAC();
    return (React.createElement(Subsection, { title: "Embedded HMAC Secret", id: "embedded-hmac-secret" },
        React.createElement(S.ContentContainer, null,
            React.createElement("div", null,
                "Use this secret to verify HMAC signatures sent to your embedded HMAC iframe.",
                ' ',
                React.createElement(ButtonClean, { label: "Learn more", href: "https://docs.fourthwall.com/embedded-hmac", target: "_blank", disabled: true })),
            React.createElement(S.ActionsContainer, null,
                loading || (updateLoading && React.createElement(Loader, null)),
                !loading && !!hmac?.hmac_secret && React.createElement(HMACDisplay, { hmac: hmac.hmac_secret }),
                !hmac?.hmac_secret && !updateLoading && (React.createElement(Button, { label: "Generate HMAC secret", onClick: () => updateHMAC([currentShopQuery.data?.id]) }))))));
};
